/* eslint-disable comma-dangle */
import * as types from '../mutation-types'
import _max from 'lodash/max'
// import collection from '@/api/collection'
import _slice from 'lodash/slice'
import _takeWhile from 'lodash/takeWhile'

const state = {
  appStatus: 'null',
  networkDelay: [], // 网络延迟数组
}

const getters = {
  networkDelay: state => {
    const len = state.networkDelay.length
    if (len <= 3) {
      return _max(state.networkDelay.map(i => i.delay))
    } else {
      // 最新 3 条
      return _max(_slice(state.networkDelay, len - 3, len).map(i => i.delay))
    }
  },
}

// |-------|--------------------------|--------|
// |  满意  |         可容忍            |  烦躁  |
// apdex = （满意样本数 + （容忍样本数 / 2））/ 总样本数

const actions = {
  // 记录网络延迟
  recordNetworkDelay({ commit, state }, data = {}) {
    data.apdex = 100

    // 计算 apdex 健康度
    const total = state.networkDelay.length
    if (total) {
      // 满意样本
      const satisfied = _takeWhile(state.networkDelay, o => o.delay < 120).length // 按自定义指标过滤满足条件的次数
      // 容忍样本
      const tolerating = _takeWhile(state.networkDelay, o => o.delay >= 120 && o.delay < 250).length // 按自定义指标过滤满足条件的次数
      // 满意度
      data.apdex = (satisfied + tolerating * 0.5) / total
    }

    commit(types.RECORD_NETWORK_DELAY, data)
  },
  // 重置网络延迟
  resetNetworkDelay({ commit }, list) {
    commit(types.RESET_NETWORK_DELAY, list)
  },
  // 设置当前应用状态
  // 无需 mutations 提交
  setAppStatus({ state }, status) {
    state.appStatus = status
  }
}

const mutations = {
  // 记录网络延迟
  [types.RECORD_NETWORK_DELAY](state, data = {}) {
    state.networkDelay.push(data)
    // 上报
    // collection.postNetstat(data);
  },
  // 重置网络延迟
  [types.RESET_NETWORK_DELAY](state, list = []) {
    state.networkDelay = list
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}
